module.exports = __webpack_public_path__ + "zvetseni-prsou_6_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_6_before.jpg
// module id = 1366
// module chunks = 0